document.addEventListener('DOMContentLoaded', (event) => {
    function reveal() {
  var reveals = document.querySelectorAll(".reveal");
  var lefts = document.querySelectorAll(".slide-left-element");
  var rights = document.querySelectorAll(".slide-right-element");

  addRemoveClass(reveals, 'active');
  addRemoveClass(lefts, 'slide-left-keyframe');
  addRemoveClass(rights, 'slide-right-keyframe');      
  
}

   function addRemoveClass(nodes,classes){
    for (var i = 0; i < nodes.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = nodes[i].getBoundingClientRect().top;
    var elementVisible = 150;

    if (elementTop < windowHeight - elementVisible) {
      nodes[i].classList.add(classes);
    } else {
      nodes[i].classList.remove(classes);
    }
  }
  }

window.addEventListener("scroll", reveal);
window.addEventListener('load', reveal);
});

